import { NgModule } from '@angular/core';
import { CompatThreatmetrixComponent } from './compat-threatmetrix.component';

@NgModule({
  declarations: [CompatThreatmetrixComponent],
})
export class CompatThreatmetrixModule {}
